import {CircularProgress, Fade, Stack, SxProps, Theme} from "@mui/material";
import {useThemeContext} from "@theme";
import {AppLogo} from "./AppLogo";

type Prop = {
  loading: boolean;
  logoAnimation?: boolean;
  sx?: SxProps<Theme>;
};

export default function LoadingView(prop: Prop) {
  const {loading, logoAnimation, sx} = prop;
  const {theme} = useThemeContext();

  return (
    <Fade in={loading} unmountOnExit>
      <Stack
        left={0}
        right={0}
        top={0}
        bottom={0}
        position="absolute"
        zIndex={1202}
        sx={sx}>
        <Stack
          bgcolor={theme.palette.background.default + "cc"}
          alignItems="center"
          justifyContent="center"
          flex={1}>
          {logoAnimation ? <AppLogo animate /> : <CircularProgress />}
        </Stack>
      </Stack>
    </Fade>
  );
}
